import React from "react";
import "./tshirtsell.css";

function TShirtSell() {
  return (
    <div className="container__landing">
      <div className="background__image">
        <div className="row__landing">
          <h1 className="announcement flashing-text">Our T-Shirt Store is Coming Soon!</h1>
            
        </div>
      </div>
    </div>
  );
}

export default TShirtSell;
